export default __webpack_public_path__ + "static/media/NewIcon.628e954c.svg";